import API from 'utils/api';
import { CheckCustomizeReportRequest, CheckCustomizeReportResponse } from './type';

export const checkCustomizeReport = (params: CheckCustomizeReportRequest) => {
    return API.post<CheckCustomizeReportResponse>(`Reports/CheckCustomizeReportBySupplier`, params);
};
